import axios from "axios";
import {
  AUTH_API_BASE_URL,
  authAxios,
  privateAxios
} from "../../../config/apiConfig";
import {
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_WITH_ACTIVE_ADDRESS_FAILURE,
  GET_USER_WITH_ACTIVE_ADDRESS_REQUEST,
  GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  OTP_FAILURE,
  OTP_REQUEST,
  OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  LOGOUT,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  SELLER_REGISTER_FAILURE,
  SELLER_REGISTER_REQUEST,
  SELLER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_FAILURE,
  USER_UPDATE_PROFILE_SUCCESS
} from "./ActionType";
import { toast } from "react-toastify";
import { getVendorProfile } from "../../../Vendor/State/Vendor/Action";
import { getEmployeeProfile } from "../../../Employee/State/Employee/Action";
import { clearAdminSession, startAdminSession } from "../../../config/adminSession";


const registerRequest = () => ({ type: REGISTER_REQUEST });
const registerSuccess = (user) => ({ type: REGISTER_SUCCESS, payload: user });
const registerFailure = (error) => ({ type: REGISTER_FAILURE, payload: error });

export const register = (userData) => async (dispatch) => {
  dispatch(registerRequest());

  try {
    const response = await authAxios.post(`user/register`, userData);
    const user = response?.data;
    // if(user.jwt){
    if (user?.status === "SUCCESS") {
      localStorage.setItem("jwt", user?.jwt);
      dispatch(registerSuccess(user?.jwt));
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error?.response?.data?.response);
    }
    dispatch(registerFailure(error?.response?.data?.response));
  }
};

const vendorRegisterRequest = () => ({ type: SELLER_REGISTER_REQUEST });
const vendorRegisterSuccess = (user) => ({
  type: SELLER_REGISTER_SUCCESS,
  payload: user
});
const vendorRegisterFailure = (error) => ({
  type: SELLER_REGISTER_FAILURE,
  payload: error
});

export const vendorRegister = (vendorData, navigate) => async (dispatch) => {
  dispatch(vendorRegisterRequest());

  try {
    const response = await authAxios.post(`vendor/register`, vendorData);
    const user = response?.data;
    if (user?.status === "SUCCESS") {
      dispatch(vendorRegisterSuccess(user));
      navigate("/")
      toast.success(user.response);
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error?.response?.data?.response);
    }
    dispatch(vendorRegisterFailure(error?.response?.data?.response));
  }
};

const loginRequest = () => ({ type: LOGIN_REQUEST });
const loginSuccess = (user) => ({ type: LOGIN_SUCCESS, payload: user });
const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });

export const login = (userData) => async (dispatch) => {
  dispatch(loginRequest());

  try {
    const response = await authAxios.post(`login`, userData);
    const user = response?.data;
    if (user?.jwt && user?.refreshJwt) {

      localStorage.setItem("jwt", user.jwt);
      localStorage.setItem("refreshJwt", user.refreshJwt);
      localStorage.setItem("role", user?.response?.role);
      if (user?.response?.role === "ADMIN") {
        startAdminSession();
      }

      dispatch(loginSuccess(user.jwt));
    } else {
      const message = user?.message || "Login failed";
      toast.error(message);
      dispatch(loginFailure(message));
    }
  } catch (error) {
    const message =
      error?.response?.data?.response || error?.message || "Login request failed";
    toast.error(message);
    dispatch(loginFailure(message));
  }
};

const otpRequest = () => ({ type: OTP_REQUEST });
const otpSuccess = (otp) => ({ type: OTP_SUCCESS, payload: otp });
const otpFailure = (error) => ({ type: OTP_FAILURE, payload: error });


export const sendOtp = (identifier, setOtpSent) => async (dispatch) => {
  dispatch(otpRequest());

  try {
    const response = await authAxios.post(`send-otp`, { identifier });
    if (response?.status === 200) {
      dispatch(otpSuccess(response));
      setOtpSent(true);
    }
  } catch (error) {
    toast.error(error?.response?.data?.response || "Otp request failed");
    dispatch(
      otpFailure(error?.response?.data || "Otp request failed")
    );
  }
};

const verifyOtpRequest = () => ({ type: VERIFY_OTP_REQUEST });
const verifyOtpSuccess = (jwt) => ({ type: VERIFY_OTP_SUCCESS, payload: jwt });
const verifyOtpFailure = (error) => ({ type: VERIFY_OTP_FAILURE, payload: error });


export const verifyOtpLogin = (identifier, otpValue, setOtpSent) => async (dispatch) => {
  dispatch(verifyOtpRequest());
  try {
    const response = await authAxios.post(`verify-otp`, {
      identifier: identifier,
      otp: otpValue
    });
    const user = response?.data;
    if (user?.jwt) {
      dispatch(logout())
      localStorage.setItem("jwt", user.jwt);
      localStorage.setItem("role", user?.response?.role);
      if (user?.response?.role === "ADMIN") {
        startAdminSession();
      }
      dispatch(verifyOtpSuccess(user.jwt));
      dispatch(getUserSuccess(user?.response));
      setOtpSent(false);
    } else {
      toast.error(user?.message || "Login failed");
      dispatch(verifyOtpFailure(user?.message || "Login failed"));
    }
  } catch (error) {
    toast.error(error?.response?.data || "Login request failed");
    dispatch(
      verifyOtpFailure(error?.response?.data || "Login request failed")
    );
  }
};

const getUserRequest = () => ({ type: GET_USER_REQUEST });
const getUserSuccess = (user) => ({ type: GET_USER_SUCCESS, payload: user });
const getUserFailure = (error) => ({ type: GET_USER_FAILURE, payload: error });

export const getUser = (jwt) => async (dispatch) => {
  dispatch(getUserRequest());

  try {
    const response = await axios.get(`${AUTH_API_BASE_URL}profile`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    const user = response?.data;
    dispatch(getUserSuccess(user));
    if (user?.role === "VENDOR") {
      dispatch(getVendorProfile());
    }
    if (user?.role === "EMPLOYEE") {
      dispatch(getEmployeeProfile());
    }


  } catch (error) {
    dispatch(getUserFailure(error?.response?.data?.response));
  }
};

const getUserWithActiveAddressRequest = () => ({ type: GET_USER_WITH_ACTIVE_ADDRESS_REQUEST });
const getUserWithActiveAddressSuccess = (user) => ({ type: GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS, payload: user });
const getUserWithActiveAddressFailure = (error) => ({ type: GET_USER_WITH_ACTIVE_ADDRESS_FAILURE, payload: error });

export const getUserWithActiveAddress = () => async (dispatch) => {
  dispatch(getUserWithActiveAddressRequest());

  try {
    const response = await privateAxios.get(`user/profile`);
    const user = response?.data;
    if (user) {
      dispatch(getUserWithActiveAddressSuccess(user));
    }
  } catch (error) {
    dispatch(getUserWithActiveAddressFailure(error?.response?.data?.response));
  }
};

const updateUserProfileRequest = () => ({ type: USER_UPDATE_PROFILE_REQUEST });
const updateUserProfileSuccess = (user) => ({ type: USER_UPDATE_PROFILE_SUCCESS, payload: user });
const updateUserProfileFailure = (error) => ({ type: USER_UPDATE_PROFILE_FAILURE, payload: error });

export const updateUserProfile = (userId, data, navigate) => async (dispatch) => {
  dispatch(updateUserProfileRequest());
  try {
    const response = await privateAxios.put(`user/user/${userId}`, data);
    const user = response?.data;
    if (user) {
      dispatch(updateUserProfileSuccess(user));
      dispatch(getUserWithActiveAddress());
      toast.success("Profile Updated Successfully!!")
      navigate("/")
    }
  } catch (error) {
    dispatch(updateUserProfileFailure(error?.response?.data?.response));
    toast.error(error?.response?.data?.response || "Something went wrong! Please Try Again!!")
  }
};


export const logout = () => async (dispatch) => {
  dispatch({ type: LOGOUT, payload: null });
  localStorage.removeItem("jwt");
  localStorage.removeItem("refreshJwt");
  localStorage.removeItem("role");
  localStorage.removeItem("permissions");
  localStorage.removeItem("currency");
  localStorage.removeItem("country");
  localStorage.removeItem("currencyRate");
  clearAdminSession();
};
